import { Drawer } from 'antd'
import React from 'react'

interface CommonDrawarProps {
  open: boolean
  onClose: () => void
  title: string | React.ReactNode
  children?: React.ReactNode
  rootClassName?: string
  className?: string
  size?: 'large' | 'default'
}

const CommonDrawar: React.FC<CommonDrawarProps> = ({
  open,
  onClose,
  title,
  children,
  rootClassName = 'sidebarDrawer',
  className = '',
  size = 'large'
}) => {
  const handleClose = () => {
    onClose()
  }

  return (
    <React.Fragment>
      <Drawer
        closable
        destroyOnClose
        title={title}
        placement='right'
        open={open}
        onClose={handleClose}
        size={size}
        rootClassName={rootClassName}
        maskClosable={false}
        keyboard={false}
        className={className}
      >
        {children}
      </Drawer>
    </React.Fragment>
  )
}

export default CommonDrawar
